import {ua,qs,getScript} from './browser';
import cookie from './cookie';
import {debug} from './message';
import '@kk/harmony-sdk';
import '@kk/quickapp-sdk';

const sdklist = {
    'wx' : '//res.wx.qq.com/open/js/jweixin-1.3.2.js',
    'qq' : '//qqq.gtimg.cn/miniprogram/webview_jssdk/qqjssdk-1.0.0.js',
    'baidu' : '//b.bdstatic.com/searchbox/icms/searchbox/js/swan-2.0.20.js',
    'alipay' : 'https://appx/web-view.min.js', //支付宝必须要这么写
    'kuaishou' : '', // kuaishou.js
    'bytedance': '//lf1-cdn-tos.bytegoofy.com/goofy/developer/jssdk/jssdk-1.0.3.js' //字节小程序sdk
}

const miniInit = (cb) => {
    return new Promise((resolve, reject) => {
        //1.设置cookie
        if (ua['miniprogram']) {
            cookie.set('passToken',qs['session']||'','',15*24*60*60, "/");
            cookie.set('session',qs['session']||'','',15*24*60*60, "/")
        }

        //2.加载sdk
        var url = '';
        if (ua['wechatmini']) url = sdklist.wx;
        if (ua['qqmini'])  url = sdklist.qq;
        if (ua['baidumini'])  url = sdklist.baidu;
        if (ua['alipaymini'])  url = sdklist.alipay;
        if (ua['kuaishoumini'])  url = sdklist.kuaishou;
        if (ua['douyinmini'])  url = sdklist.bytedance;

        if (url) {
            getScript(url,function(){
                console.log('mini-sdk loaded')
                resolve();
                cb && cb();
            })
        } else {
            // if(ua['harmony']) {
            //     import('@kkmh/harmony-sdk').then(() => {
            //         console.log('harmony mini-sdk loaded');
            //         resolve();
            //         cb && cb();
            //     })
            // }
            let timer=setTimeout(()=>{
                resolve();
                cb && cb();
                clearTimeout(timer);
            },150)
        }
    })
}
/*
    mini_action_type : 
    navigateTo (default)
    redirectTo 
    navigateBack {}
*/
const miniNav = (url, opt={}) => {
    let { mini_action_type = 'navigateTo' } = opt;
    // 因小程序拆包 路径修改 统一处理
    url = formatUrl(url)
    
    //微信小程序
    if (ua.wechatmini) {
        wx.miniProgram[mini_action_type]({url: url})
        debug(`[wechatmini-${mini_action_type}]`,url);
    }
    //qq小程序
    if (ua.qqmini) {
        qq.miniProgram[mini_action_type]({url: url})
        debug(`[qqmini-${mini_action_type}]`,url);
    }
    //baidu小程序
    if (ua.baidumini) {
        swan.webView[mini_action_type]({url: url})
        debug(`[baidumini-${mini_action_type}]`,url);
    }
    //支付宝小程序
    if (ua.alipaymini) {
        my[mini_action_type]({url: url})
        debug(`[alipaymini-${mini_action_type}]`,url);
    }
    //快手小程序
    if (ua.kuaishoumini) {
        ks[mini_action_type]({url: url})
        debug(`[kuaishoumini-${mini_action_type}]`,url);
    }
    // 鸿蒙小程序
    if(ua.harmony) {
        harmony[mini_action_type]({url: url})
        debug(`[harmony-${mini_action_type}]`,url);
    }
    //抖音小程序
    if (ua.douyinmini) {
        tt.miniProgram[mini_action_type]({url: url})
        debug(`[douyinmini-${mini_action_type}]`,url);
    }
    if(ua.quickapp) {
        quickapp[mini_action_type]({url: url})
    }

}
// 处理路径 https://wiki.quickcan.com/pages/viewpage.action?pageId=391446537
// 页面变动：/pages/***/***  （拆包之前）     /subpack-auxiliary/pages/***/***  （拆包后，加一层路径 /subpack-auxiliary）
function formatUrl(url) {
    // 快手暂不支持 分包(2021-12-08 版本快手小程序开始支持分包)
    // if (ua['kuaishoumini']) return url
    var oldList = [
        '/pages/buykkb/buykkb', // kkb支付购买页
        '/pages/buyvip/buyvip', // vip支付购买页
        '/pages/coupon-list/coupon-list', // 代金劵列表页
        '/pages/coupon-detail/coupon-detail', // 代金劵详情页
        '/pages/vip-center/vip-center', // 会员中心页
        '/pages/wallet/wallet', // 钱包页
        '/pages/vip-topic-list/vip-topic-list', // 会员专题列表页
        '/pages/feedback/feedback', // 问题反馈页
        'pages/bought/bought', // 已购漫画/我的漫画/自动购买管理
        'pages/setting/setting', // 设置
    ];
    // 跳转路径是否在 变动的路径中
    var flag = false
    oldList.forEach(function (item) {
        if (url.indexOf(item) >= 0) { flag = true }
    })
    if (!flag) return url

    var prefix = '/subpack-auxiliary'
    var version = ua.miniversion
    var isNewUrl = url.indexOf(prefix) >= 0
    // 新版本要跳转的地址
    var newUrl = isNewUrl ? url : (prefix + url)
    // 老版本要跳转的地址
    var oldUrl = isNewUrl ? url.replace(prefix, '') : url
    // 快手小程序 大于574000 跳转新地址
    if (ua['kuaishoumini']) return version >= 595000 ? newUrl : oldUrl
    // 百度小程序 大于574000 跳转新地址
    if (ua['baidumini']) return version > 574000 ? newUrl : oldUrl
    // 微信 qq 支付宝 大于583000 跳转新地址
    if (ua['wechatmini'] || ua['qqmini'] || ua['alipaymini']) return version > 583000 ? newUrl : oldUrl
    // 抖音 使用新地址
    if (ua['douyinmini']) return newUrl;
    // 鸿蒙没有拆包，固定使用旧地址
    if (ua['harmony']) return oldUrl;
    // 快应用 使用新地址
    if (ua['quickapp']) return newUrl;
}

// 小程序各端是否支持购买，安卓全系支持，ios仅支持支付宝&夸克
const mini_is_pay = () => {
    let isPay = true;
    if (ua.miniprogram && ua.iphone) {
        isPay = ua.alipaymini && !ua.ucmini;
    }
    return isPay;
}

// 小程序中获取uid，openid
const mini_id = () => {
    let kkid = qs["kkid"] || "";
    kkid = decodeURIComponent(kkid);
    let user_id = kkid.split("#")[1] || "";
    let open_id = (kkid.split(":")[1] || "").split("#")[0] || "";
    return {
        user_id,
        open_id
    };
}

// 小程序相关属性，返回对象，platform（平台类型）、is_pay（是否可以支付）、order_from（付费接口from）
const miniData = (() => {
    let from = "1";
    let platform = "";
    let is_pay = mini_is_pay();
    let { 
        user_id, 
        open_id 
    } = mini_id();

    if (ua.wechatmini) {
        from = "3";
        platform = "wechat";
    } else if (ua.qqmini) {
        from = "4";
        platform = "qq";
    } else if (ua.baidumini) {
        from = "8";
        platform = "baidu";
    } else if (ua.kuaishoumini) {
        from = "12";
        platform = "kuaishou";
    } else if (ua.alipaymini) {
        if (ua.quarkmini) {
            from = "14";
            platform = "quark";
        } else if (ua.ucmini) {
            from = "13";
            platform = "uc";
        } else {
            from = "9";
            platform = "alipay";
        }
    } else if (ua.harmony) {
        from = "20";
        platform = "harmony";
    } else if (ua.douyinmini) {
        from = "18";
        platform = "douyin";
    } else if (ua.quickapp) {
        from = "3";
        platform = "quickapp";
    };
    return {
        user_id, // 用户ID，未登录为空
        open_id, // openID
        is_pay, // 是否可以支付，默认true
        order_from: from, // 付费接口from，默认1
        platform // 来源平台，默认空
    };
})();

export {
    miniInit,
    miniNav,
    miniData
}



